var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-wrapper"},[_c('div',{staticClass:"no-data"},[(_vm.icon)?_c('a-icon',{attrs:{"type":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.img)?_c('img',{attrs:{"src":_vm.img.src,"width":_vm.img.width,"alt":"ico"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-data-text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }